import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import Api from '../../Api';

const socialMap = {
  'facebook': {
    'field': 'facebook_handle',
    'prefix': 'http://facebook.com/'
  },
  'twitter': {
    'field': 'twitter_handle',
    'prefix': 'http://twitter.com/'
  },
  'instagram': {
    'field': 'instagram_handle',
    'prefix': 'http://instagram.com/'
  },
  'youtube': {
    'field': 'youtube_handle',
    'prefix': 'http://youtube.com/'
  },
  'pinterest': {
    'field': 'pinterest_handle',
    'prefix': 'http://pinterest.com/'
  }
};

export default class BrandHeader extends React.Component {
  static propTypes = {
    brand: PropTypes.object,
    recommendations: PropTypes.array
  };

  constructor(props) {
    super(props);

    Api.Utils.bindThis(
      this,
      [
        'brandImageUrl',
        'brandImage',
        'logoGrid',
        'socialIcons',
        'brandAbout'
      ]
    );
  }

  brandImageUrl() {
    let brandInfo = this.props.brand;

    if (!brandInfo) return null;
    if (brandInfo.images.length <= 0) return null;

    return brandInfo.images[0].url;
  }

  brandImage() {
    let url = this.brandImageUrl();
    if (!url) return null;

    return <img role="presentation" src={url} />;
  }

  logoGrid() {
    if (!this.props.recommendations || this.props.recommendations.length <= 0) return;
    if (!this.props.brandInfo) return;

    let urls = [];

    // Brand Image
    if (this.props.brandInfo.images.length > 0) urls.push(this.props.brandInfo.images[0].url);

    this.props.recommendations.forEach((product) => {
      let url = null;
      if (product.images.length > 0) {
        url = product.images[0].url;
      } else if (product.options.length > 0 && product.options[0].images.length > 0 ) {
        url = product.options[0].images[0].url;
      }

      if (url) urls.push(url);
    });

    if (urls.length <= 0) return null;

    let idx = 0;
    while (urls.length < 4) {
      urls.push(urls[idx++]);
    }

    let contents = urls.map((url, idx) => {
      return (
        <span className="logo-image-block" key={'brand-header-logo-image-block-' + idx}>
          <img role="presentation" src={url} />
        </span>
      );
    });

    return <span className="logo-image-mosaic">{contents}</span>;
  }

  socialIcons() {
    if (!this.props.brand) return null;

    let socialIcons = Object.keys(socialMap)
      .map((socialKey) => {
        let socialFields = socialMap[socialKey];
        if (!this.props.brand[socialFields.field]) return null;
        return (
          <a
            className="social-link"
            key={this.props.brand.token + '-social-' + socialKey}
            href={socialFields.prefix + this.props.brand[socialFields.field]}
            target="_new">
            <FontAwesome name={socialKey} />
          </a>
        );
      });

    if (socialIcons.length === 0) return null;

    return <div className="social-icons">{socialIcons}</div>;
  }

  brandAbout() {
    if (!this.props.brand || !this.props.brand.description) return null;

    return (
      <div className="brand-about">
        <p>{this.props.brand.description}</p>
      </div>
    );
  }

  render() {
    let brandInfo = this.props.brand;
    if (!brandInfo) return null;

    let closestBrandRetailer = null;
    if (this.props.closestBrandRetailer) {
      let distance = null;
      if (this.props.closestBrandRetailer < 1) {
        distance = 'less than a mile away';
      } else if (this.props.closestBrandRetailer > 5) {
        distance = 'more than 5 miles away';
      } else {
        distance = Math.ceil(this.props.closestBrandRetailer) + ' miles away';
      }
      closestBrandRetailer = <span className="distance"><FontAwesome name="map-marker" /><span>Nearest known store carrying {brandInfo.name} <strong>{distance}</strong>.</span></span>
    }

    let brandUrl = brandInfo.url;
    if (brandUrl) {
      brandUrl = brandUrl.replace(/^https?:\/\/([^/]*)\/?/, '$1');
    }

    let brandStyle = {};
    let brandImageUrl = this.brandImageUrl();
    let classNames = [ 'brand-header' ];

    if (brandImageUrl) {
      brandStyle.backgroundImage = `url(${brandImageUrl})`;
    } else {
      classNames.push('no-image');
    }

    let brandMinimum = null;
    if (brandInfo.minimum_order_amount_cents) {
      let minimumText = Api.Utils.formatCents(brandInfo.minimum_order_amount_cents);
      if (minimumText.indexOf('.') > 0) {
        minimumText = minimumText.substr(0, minimumText.indexOf('.'));
      }
      brandMinimum = <span className="brand-minimum">Minimum ${minimumText}</span>;
    } else {
      brandMinimum = <span className="brand-minimum">No Minimum</span>;
    }

    return (
      <div className={classNames.join(' ')} id={`brand-header-${brandInfo.token}`} style={brandStyle}>
        {this.socialIcons()}
        <div className="inner-wrapper">
          <div className="left-block">
            <div className="brand-name">{brandInfo.name}</div>
            <div className="brand-info-line">
              <span className="brand-from">{brandInfo.from}</span>
              <span className="brand-url">{brandUrl}</span>
              {brandMinimum}
            </div>
            {this.brandAbout()}
            {closestBrandRetailer}
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Brand/header.js
 **/